import { PolarAngleAxis, PolarGrid, Radar, RadarChart } from "recharts"
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart"
import type { Result } from "@/utils/types"
import { languages } from "@/lib/utils"

type LanguageRadarProps = {
  highscores: Result[]
}
export const LanguageRadar: React.FC<LanguageRadarProps> = ({ highscores }) => {
  // chatGPT code
  const chartData = Object.values(
    highscores.reduce<Record<string, { language: string; wpm: number }>>((acc, result) => {
      const lang = languages[result.language as keyof typeof languages].emoji //result.language
      const wpm = result.time_mode > 0 ? result.char_count / result.time_mode : 0

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!acc[lang] || wpm > acc[lang].wpm) {
        acc[lang] = { language: lang, wpm }
      }

      return acc
    }, {}),
  )
    .sort((a, b) => b.wpm - a.wpm)
    .slice(0, 6)

  return (
    <ChartContainer config={{}} className="h-35 w-35">
      <RadarChart data={chartData}>
        <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
        <PolarGrid gridType="circle" radialLines={false} />
        <PolarAngleAxis dataKey="language" />
        <Radar
          dataKey="wpm"
          fill="white"
          fillOpacity={0.6}
          dot={{
            r: 4,
            fillOpacity: 1,
          }}
        />
      </RadarChart>
    </ChartContainer>
  )
}
